import {useAppSelector} from '../../../store/store';
import buttonStyles from '../../../components/button/button.module.scss';
import formStyles from '../../../components/form/form.module.scss';
import {Button} from '../../../components/button/button';
import {ButtonColorType} from '../../../enums/button_color_type.ts';
import {Status} from '../../../enums/status.ts';
import {CenteredSpinner} from '../../../components/spinner/centered_spinner.tsx';
import {__} from '../../../support/lang/translations.ts';
import {classNames} from '../../../support/classnames.ts';
import {SimpleSelect} from '../../../components/select/simple_select.tsx';
import {ShowElement} from '../../../components/utility/show_element_wrapper.tsx';
import {HideElement} from '../../../components/utility/hide_element_wrapper.tsx';

export function TimePickerTitle() {
    return (
        <>
            <h1>{__('appointment.time_picker.title')}</h1>
            <h2>{__('appointment.time_picker.subtitle')}</h2>
        </>
    );
}

interface ContentProps {
    availableTimes: string[];
    time: string | null;
    onTimeChange: (time: string | null) => void;
    isEditing: boolean;
    onEditClick: () => void;
}

interface Option {
    label: string;
    value: string;
}

export function TimePickerContent(props: ContentProps) {
    const customerInfo = useAppSelector((state) => state.customerInfo);

    if (customerInfo.status !== Status.FULFILLED) {
        return <CenteredSpinner />;
    }

    const timeOptions: Option[] = props.availableTimes
        ?.filter((at): at is NonNullable<typeof at> => at != null)
        .map((at) => {
            return {
                label: at || '',
                value: at || '',
            };
        });

    return (
        <>
            <h3>{__('appointment.date_picker.title_appointment')}</h3>
            <div className={classNames(formStyles.form, formStyles.form_centered)}>
                <div className={formStyles.form__grid}>
                    <div className={formStyles.grid__custom}>
                        <fieldset>
                            <label data-grid-column-start={1} data-grid-column-end={13}>
                                {__('appointment.time_picker.fields.time')}
                                <SimpleSelect
                                    value={props.time}
                                    options={timeOptions}
                                    onChange={(value) => props.onTimeChange(value || null)}
                                    emptyLabel={
                                        __('general.choose_value', {
                                            name: __('appointment.select.fields.time') as string,
                                        }) as string
                                    }
                                />
                            </label>
                        </fieldset>
                    </div>
                </div>
            </div>
        </>
    );
}

interface FooterProps {
    onPreviousSlide: () => void;
    onNextSlide: () => void;
    nextIsDisabled: boolean;
}

export function TimePickerFooter(props: FooterProps) {
    return (
        <>
            <ShowElement size={'sm'}>
                <Button
                    className={buttonStyles.button_step}
                    type="button"
                    onClick={() => props.onPreviousSlide()}
                    colorType={ButtonColorType.Black}
                >
                    <i className="fa-light fa-chevron-left" />
                    <span>{__('appointment.time_picker.footer.buttons.previous')}</span>
                </Button>
            </ShowElement>

            <HideElement size={'sm'}>
                <span />
            </HideElement>

            <Button
                className={buttonStyles.button_step}
                disabled={props.nextIsDisabled}
                type="button"
                onClick={() => props.onNextSlide()}
                colorType={ButtonColorType.Green}
            >
                <i className="fa-light fa-check" />
                <span>{__('appointment.time_picker.footer.buttons.next')}</span>
            </Button>
        </>
    );
}
